import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import LinkFields from "./fields";
import EmbedUtils from "../../gd/utils/embed";
import ErrorFieldIncorrectValue from "../../gd/validation/error-field-incorrect-value";


export default class Link extends ModelEntity {

    // public id       : ID                // ???
    public label    : string            // link visible label
    public url      : string

    public fields   : LinkFields = new LinkFields()

    constructor(data: any) {

        super(data['id'], EntityType.DYNAMIC_MODEL)

        // this.id     = _.get(data, 'id', '')
        this.label  = _.get(data, 'label', '')
        this.url    = _.get(data, 'url', 'https://')
    }

    validate():ErrorProto[] | null  {

        const errors : any[] = []

        if (!this.url) errors.push(new ErrorFieldRequired(this.fields.url))

        // if (!!this.url && !EmbedUtils.isLinkV2(this.url)) errors.push(new ErrorFieldIncorrectValue(this.fields.url)) // It's not important

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON(): JSONObject {
        return {
            id      : this.id,
            label   : this.label,
            url     : this.url
        }
    }

}
